import axios from 'axios';

export default async function getUserLocationGroups({
  accessToken,
  userId,
  page = 0,
  pageSize = 20,
  query = '',
  setTokenLikeExpired,
  setIsLoading,
}) {
  try {
    if (setIsLoading) setIsLoading(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_LOCATION_GROUPS_API_URL}/user/${userId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  } finally {
    if (setIsLoading) setIsLoading(false);
  }
}
